import { useEffect,useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

import { Pagination,Table } from "antd";
import { getExpenseApi,getExpensesApi } from "api/services/expense";
import Image from "components/Image";
import { useLocation,useNavigate,useSearchParams } from "react-router-dom";
import { formatDateHandler2 } from "utils/common";
import { defaultPagination,handlePageChange,itemRender,pageSizeOptions } from "utils/table";

import { useSelector } from 'react-redux';

import { format } from "date-fns";

import { Button } from "components/Button";
import { SkeltonLoader } from "components/skeltonLoader";
import { useMediaQuery } from "react-responsive";
import { opensEditor } from "components/modelpopup/expenseActions";


const Estimates = ({userData}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [dateTwo, setdateTwo] = useState(false);
  const [setSelectedOption] = useState(null);
  const [selectedDateTwo, setSelectedDateTwo] = useState(null);

  
  const [loading, setLoading] = useState(false)
  const [expenses, setExpenses] = useState([])
  const [expensesLoading, setExpensesLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [selectedExpense, setSelectedExpense] = useState("");
  const [expenseModal, setExpenseModal] = useState(false);
  const [expenseStatusModal, setExpenseStatusModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");

  const {
    user, userLoading   
} = useSelector((state) => state.user);
  const navigate = useNavigate();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  

  useEffect(()=>{
    // console.log(id, modal, "MMM")
    const id = queryParams.get("id"); // Get 'id' param
    const modal = queryParams.get("modal"); // Get 'name' param
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(location?.search);
    console.log(queryParams, id ,  modal, queryParams,"MMM")

    if(id && modal){
      getExpenseApi(id, {}).then(response=>{
        setSelectedExpense(response?.data)
        setExpenseStatusModal(true)
      })
      
    }

  },[])


  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})


// const getFilterParams = useCallback(()=>{
//   let filter_params = filterHandler(filters)

//     return filter_params
        
// })
useEffect(()=>{
  // setExpenseParams(pageSettings)
},[pageSettings])

const setExpenseParams = (pageData) => {
//   let filter_params = getFilterParams()
  let params = {
      size: pageData?.pageSize,
      page: pageData?.page,
      sort_by: pageData?.sortBy || "",
      sort_type: pageData?.sortType || "",
    //   ...filter_params
  }
  setSearchParams(params)
}
  const fetchExpensesList = () => {
    setLoading(true)
    setExpensesLoading(true)
    // let filter_params = getFilterParams()
    let filter_params = {}
    if(filter_params?.reference_date){
      filter_params.reference_date = format(new Date(filter_params.reference_date), "yyyy-MM-dd")
  }
  if(filter_params?.posting_date){
      filter_params.posting_date = format(new Date(filter_params.posting_date), "yyyy-MM-dd")
  }



    getExpensesApi({
      sort_by:pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      company_user: userData?.id,
    //   ...filter_params

    }).then(res => {
      if(view=="grid" && pageSettings?.page!==1){
        setExpenses([...expenses,...res.data.results]);

      }else{
        setExpenses(res.data.results)

      }

     
      setLoading(false)
      setShowFilterDrawer(false)
      setExpensesLoading(false)

    }).catch(e=>{
      setExpenses([])
      setLoading(false)
      setExpensesLoading(false)
    })

  }
  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    setPageSettings(pageData)
  };

  const handleExpenseAction = (record)=>{
    setSelectedExpense(record)
    setExpenseModal(true)
  }
  const handleExpenseStatusAction = (record)=>{
    setSelectedExpense(record)
    setExpenseStatusModal(true)
  }


  useEffect(()=>{
    if(userData?.id){
      fetchExpensesList()
    }
  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, userData])
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      // sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>{
          if(opensEditor(user, record)){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }}  className="table-avatar d-flex">
         {text}
        </h2>
      ),
      sorter: (a, b) => a.id - b.id, 
      defaultSortOrder: "ascend"

    },
    {
      title: "Name",
      dataIndex: "first_name",
      // sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>{

          if(opensEditor(user, record)){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
          
          }}  className="table-avatar d-flex">
          <a 
          
          className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image src={record?.company_user?.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </a>
          <div>
          <a 
          // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
          className="profile-split d-flex flex-column">
            {record.company_user?.first_name} {record?.company_user?.last_name} 
          </a>
          {record?.company_user?.emp_no && (
            <span className="small text-muted">{ record.company_user?.emp_no}</span>
          )}

        
          </div>
        </h2>
      ),

    },
    // {
    //   title: "Position",
    //   dataIndex: "position_name",
    //   // sorter: true,
    //   render: (text, record, index) => (       
    //       <span>{record?.company_user?.position_name}</span>        
     
    //   ),
    //   align:"center"

    // },
    // {
    //   title: "Claim No",
    //   dataIndex: "claim_no",
    //   render: (text,record) => <span>{text}</span>,
    //   sorter: true,
    // },
    {
      title: "Ref Date",
      dataIndex: "reference_date",
      render: (text,record) => <span>{formatDateHandler2(text)}</span>,
      sorter:true,
    },

    {
      title: "Posting Date",
      dataIndex: "posting_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <span>{text}</span>,

      sorter: true,
      align:"center"
    },

 
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      align: "center",
      render: (text) => (
        <div className="dropdown action-label text-center">
         <span
          className={`badge badge-soft-${
            text === "pending"
              ? "warning"  // Yellow
              : text === "approved"
              ? "success"  // Green
              : text === "cancelled"
              ? "dark" // Grey
              : "danger"  
  }`}
>
  {text}
</span>

        </div>
      ),
    },
 
    {
      title: "Next Approver",
      dataIndex: "approved_by",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          {
            record?.current_approver &&
            <>
                    <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="avatar">
          {/* <img alt="" src={record.profile_image} /> */}
          <Image src={record?.current_approver?.profile_image}  type="user" style={{ objectFit: "cover" }} />
        </a>
        <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="profile-split d-flex flex-column">
          {record.current_approver?.first_name} {record?.current_approver?.last_name}
          {record?.current_approver?.emp_no && (
            <span className="small text-muted">{ record.current_approver.emp_no}</span>
          )}
        </a>
            </>
          }

      </h2>
      ),
    },
    {
      title: "Approved on",
      dataIndex: "approved_on",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
    },
    {
      title: "Action",
      className: "text-end",
      sorter: true,
      render: (text,record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={()=>{
                if(opensEditor(user, record)){
                  handleExpenseAction(record)
                }else{
                  handleExpenseStatusAction(record)
                }
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Update
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              onClick={()=>handleExpenseStatusAction(record)}
            >
              <i className="fa fa-pencil m-r-5" /> Change status
            </Link> */}
            
          </div>
         

        </div>
      ),
    },
  ];
  const EmptyState = () => (
    <div className="col-12" style={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: isMobile ? "60px 20px" : "80px 40px",
      textAlign: "center"
    }}>
      <div style={{
        width: isMobile ? "120px" : "150px",
        height: isMobile ? "120px" : "150px",
        marginBottom: "24px",
        opacity: 0.6
      }}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h3 style={{ 
        fontSize: isMobile ? "18px" : "20px", 
        fontWeight: "600", 
        color: "#1f2937",
        marginBottom: "8px"
      }}>
        No Expenses Found
      </h3>
      <p style={{ 
        fontSize: isMobile ? "14px" : "15px", 
        color: "#6b7280",
        margin: 0,
        maxWidth: "400px"
      }}>
        This employee doesn't have any expense records yet.
      </p>
    </div>
  );

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else if (expenses.length === 0) {
      return <EmptyState />;
    } else {
      return (
        <>
          {expenses.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6" style={isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : {}}>
            <div className="contact-grid" style={isMobile ? { margin: 0 } : {}}>
                <div className="grid-head">
                    <div className="users-profile">
                        <a onClick={()=>{
          if(opensEditor(user, record)){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }}  className="avatar">
                            {/* <img src={employee?.profile_image} alt="" /> */}
                            <Image  src={record.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        </a>
                        <h5 className="name-user">
                            <a onClick={()=>{
          if(opensEditor(user, record)){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }} >{record.company_user?.first_name} {record?.company_user?.last_name} </a>
                            <span>{record.company_user?.emp_no}</span>
                        </h5>
                    </div>
                 
                </div>
                <div className="grid-body">
                    <div className="address-info">
                        <span>
                            <i className="la la-calendar" />
                            Reference : {formatDateHandler2(record.reference_date)}
                            {/* sharon@gmail.com */}
                        </span>
                        <span>
                            <i className="la la-calendar" />
                            Created : {formatDateHandler2(record.created_at)}
                        </span>
                        <span>
                            <i className="la la-user" />
                            Next Approver: {record.current_approver?.first_name} {record?.current_approver?.last_name}
                        </span>
                    </div>
                    <div className="grid-badges">
                        <span className="badge badge-soft-warning">{record?.approval_status}</span>
                    </div>
                </div>
               
            </div>
        </div>
          
          ))}
        </>
      );
    }
  };

  const handleGridChange = (page, size) =>{
    console.log(page, size, ")))))))))))))")
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  return (
    <>

        {view == "grid" ? (
        <div className="row" style={isMobile ? { marginLeft: "8px", marginRight: "8px" } : {}}>
              {!loading && expenses.length === 0 ? (
                <EmptyState />
              ) : (
                <GridView />
              )}
              {expenses.length > 0 && (
                <div className="my-2 d-flex justify-content-end ">
                  <div className="col-sm-12 col-md-6 ">
                    <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                {!loading && expenses.length === 0 ? (
                  <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                    <EmptyState />
                  </div>
                ) : (
                  <div className="card shadow-sm" style={{ borderRadius: "8px", border: "none", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                    <style>{`
                      .modern-table .ant-table-tbody > tr {
                        background-color: #ffffff !important;
                      }
                      .modern-table .ant-table-tbody > tr:hover > td {
                        background-color: #f5f5f5 !important;
                      }
                      .modern-table .ant-table-thead > tr > th {
                        background-color: #f8f9fa !important;
                        font-weight: 600;
                        color: #333;
                        border-bottom: 2px solid #e0e0e0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-tbody > tr > td {
                        border-bottom: 1px solid #f0f0f0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                        border-top: 1px solid #f0f0f0;
                        background-color: #ffffff;
                        border-bottom-left-radius: 12px;
                        border-bottom-right-radius: 12px;
                      }
                    `}</style>
                    <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                        className="mb-0 modern-table"
                        style={{ 
                          borderRadius: "12px",
                          minWidth: "100%"
                        }}
                        scroll={{ x: "max-content" }}
                    columns={columns}
                    dataSource={expenses}
                    rowKey={(record) => record.id}
                    loading={expensesLoading}
                    pagination={{
                      total: pageSettings?.total,
                      pageSize: pageSettings?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: pageSizeOptions,
                      itemRender: itemRender,
                      position: "right",
                      current: pageSettings?.page,
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                          style: { padding: "16px" }
                    }}
                    onChange={handleChange}
                  />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
      
   



    </>
  );
};

export default Estimates;
